export const filterKeyToLabel = (key) => {
  const map = {
    selectedGym: "Selected Gym",
    selectedGyms: "Selected Gyms",
    isActive: "Status",
    selAddNotAddToLead: "Add/Not Add To Lead",
    selectedODMStatus: "ODM Status",
    selectedLMSSorting: "LMS Sorting",
    selectedDateAddedSorting: "Date Added Sorting",
    selectedGender: "Gender",
    selAutomationKeyword: "Automation Keyword",
    selLeadStatus: "Lead Status",
    selUTMSource: "UTM Source",
    selUTMMedium: "UTM Medium",
    selUTMContent: "UTM Content",
    selUTMTerm: "UTM Term",
    selUTMCampaign: "UTM Campaign",
    selAssignedLeadDay: "Assigned Lead Day",
    selAssignedLeadHour: "Assigned Lead Hour",
    selAssignedLeadMinute: "Assigned Lead Minute",
    selAssignLeadFollowupDay: "Assign Lead Followup Day",
    selAssignLeadFollowupHour: "Assign Lead Followup Hour",
    selAssignLeadFolloupMinute: "Assign Lead Followup Minute",
    leadAddDateFrom: "Lead Add Date (From)",
    leadAddDateTo: "Lead Add Date (To)",
    leadConvertedDateFrom: "Lead Converted Date (From)",
    leadConvertedDateTo: "Lead Converted Date (To)",
    searchString: "Search",
    isOperatorValueShow: "Operator Value Show",
  };
  return (
    map[key] ||
    key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())
  );
};

export const getFilterValue = (val) => {
  if (val === null || val === undefined || val === "") return null;
  if (Array.isArray(val)) {
    return val.map((v) => v?.label || v?.value || v).join(", ");
  }
  if (typeof val === "object" && val.label) return val.label;
  return val;
};

export function replaceTemplateVariablesWithLabels(
  body,
  selectedTemplateVariables,
  variables
) {
  if (!body || !selectedTemplateVariables || !variables) return body;

  let result = body;
  Object.entries(selectedTemplateVariables).forEach(([num, variableId]) => {
    const found = variables.find((v) => v.value === variableId);
    const label = found
      ? `<span class="template-var">${found.label}</span>`
      : variableId;
    const regex = new RegExp(`{{\\s*${num}\\s*}}`, "g");
    result = result.replace(regex, label);
  });
  return <span dangerouslySetInnerHTML={{ __html: result }} />;
}

export const getCommonFilterPageName = (pageName) => {
  switch (pageName) {
    case "odm":
      return "one-day-membership";
    case "wati":
      return "one-day-membership";
    case "lms":
      return "lead-management";
    case "walkins":
      return "walkins-leads";
    case "recurring":
      return "recurring-999";
    case "unpaid_members":
      return "unpaid-members";
    case "renewal_members":
      return "renewal-members";
    default:
      return pageName;
  }
};
